import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RiesgoService {
  token: string = '';
  baseUrl = environment.apiEndpoint;

  constructor(private http: HttpClient) {
    this.token = environment.token;
  }

  private header(accessToken: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json',
      "Accept": "application/json",
      "Authorization": "Bearer " + accessToken
    });
    return headers;
  }

  getRiego(): Observable<any> {
    return this.http.get(this.baseUrl + 'poaRiesgos', { headers: this.header(this.token) });
  }

  getRiegoById(id: number): Observable<any> {
    return this.http.get(this.baseUrl + 'poaRiesgo/' + id, { headers: this.header(this.token) });
  }

  postRiego(riego: any): Observable<any> {
    return this.http.post(this.baseUrl + 'poaRiesgo', riego, { headers: this.header(this.token) });
  }

  putRiesgo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.put(this.baseUrl + 'poaRiesgo', bodyString, { headers: this.header(this.token) });
  }

  deleteRiego(id: number): Observable<any> {
    return this.http.delete(this.baseUrl + 'poaRiesgo/' + id, { headers: this.header(this.token) });
  }

  postAddRiesgo(data: any): Observable<any> {
    let bodyString = JSON.stringify(data);
    return this.http.post(this.baseUrl + 'poaRiesgo', bodyString, { headers: this.header(this.token) });
  }
}
